<template>
  <div class="modal-alpaclass d-flex flex-column gap-4">
    <snow-select
      v-model="form.product_id"
      id="product-select"
      label="Nome do produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <snow-input
      v-model="form.description"
      id="description"
      label="Descrição da integração (Opcional)"
    />
    <snow-input
      v-model="form.token"
      id="token"
      label="Token"
      :rules="rules.token"
      required
    />
    <snow-input
      label="ID da entrega (API)"
      id="delivery-id"
      type="number"
      v-model="form.delivery_id"
      :rules="rules.delivery_id"
      required
    />

    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        :text="isEdit ? 'Salvar' : 'Integrar'"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
import { required } from "@/functions/validation";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["description", "delivery_id", "product_id", "status", "token", "name"],
        {
          name: "alpaclass",
          ...this.integrationToEdit
        }
      )
    };
  },
  computed: {
    isValid() {
      return this.form.delivery_id && this.form.product_id && this.form.token;
    },
    rules() {
      return {
        token: [required()],
        delivery_id: [required()]
      };
    }
  }
};
</script>
